
	import { defineComponent } from "vue";
	import DialogBase from "./DialogBase.vue";

	interface DialogConfirmData {
		title: string,
		message: string,
		defaultValue: string
	}

	export default defineComponent({
		extends: DialogBase,		
		data() {
			const dialogDataTyped = this.dialogDataGet<DialogConfirmData>();
			return {
				dialogDataTyped,
				value: dialogDataTyped.defaultValue
			}
		},
		methods: {
			ok() {
				this.returnOk(this.value);
			},
			cancel() {
				this.returnCancel();
			}
		}
	});
